import * as Yup from 'yup'
import { validation as validationCurriculum} from './DataForm/CurriculumDataForm/validation'
import { validation as validationDatosPersonales} from './DataForm/DatosPersonalesDataForm/validation'

export const validationSchema = Yup.object().shape({
    ...validationCurriculum,
    ...validationDatosPersonales,
})